module.exports = function () {
    const woocommerce = document.querySelector(".woocommerce");
    const CustomSelect = require('../custom-select');
    
    if ( woocommerce ) {
        function createCustomSelect() {
            if ( !document.querySelector(".custom-select") ) {
                const customSelect = new CustomSelect(document.querySelector(".shipping_method"), {
                    afterElement: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"><path fill="#516783" d="M15.71 5.71a.999.999 0 0 0-1.42 0l-4.58 4.58a1 1 0 0 1-1.42 0L3.71 5.71a1 1 0 1 0-1.42 1.41l4.59 4.59a3 3 0 0 0 4.24 0l4.59-4.59a1 1 0 0 0 0-1.41Z"/></svg>',
                })
            }
        }
        
        function setCalculatorButton () {
            if ( document.querySelector(".shipping-calculator-button:not(.init)") ) {
                const button = document.querySelector(".shipping-calculator-button");
                button.classList.add("init");
                button.addEventListener("click", (e) => {
                    e.currentTarget.classList.toggle("active")
                })
            }
        }
        
        function updateToolsWrap() {
            createCustomSelect();
            setCalculatorButton();
        }
        
        updateToolsWrap();

        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList")
                   updateToolsWrap()
            }
        };

        const config = { attributes: false, childList: true, subtree: true };
        const observer = new MutationObserver(callback);

        observer.observe(woocommerce, config);
    }
}